export default __webpack_public_path__ + "static/media/logo-maker.564bded4.png";